/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#getPageWidth__anchor
 */
export default pageNumber => window.documentViewer.getPageWidth(pageNumber);
